import { render, staticRenderFns } from "./CompleteCart.vue?vue&type=template&id=6c5d88c6&scoped=true&"
var script = {}
import style0 from "./CompleteCart.vue?vue&type=style&index=0&id=6c5d88c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5d88c6",
  null
  
)

export default component.exports